import Model from "../../Model.js";

/**
 * `ReportRow` is a class representing a single calculated row of an invoice report.
 *
 * @param {string} reference - The owner of the invoice row. This can
 *   be a customer's name or a supplier's name
 * @param {{}} cells - This contains the value of each column for this
 *   row. The object has column labels {string} as keys and
 *   corresponding numbers as values
 */
export default class ReportRow extends Model {
	constructor({ reference, cells = {} }) {
		super(...arguments);
		this._reference = reference;
		this._cells = cells;
	}

	getReference() {
		return this._reference;
	}

	getData() {
		return { reference: this._reference, ...this._cells };
	}

	static transformMaterializationData(data) {
		data.cells = {};

		data.rowCells.forEach((cell) => {
			data.cells[cell.key] = cell.value || 0;
		});
	}
}
